import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import DetailField from '../ui/DetailField';
import Button from '../ui/Button';

interface EmailContent {
  subject: string;
  body: string;
}

interface EmailContentModalProps {
  emailContent: EmailContent | null;
  onClose: () => void;
}

const EmailContentModal: React.FC<EmailContentModalProps> = ({
  emailContent,
  onClose,
}) => {
  if (!emailContent) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[90vh] flex flex-col">
        {/* Modal Header */}
        <div className="flex items-center justify-between flex-shrink-0 px-6 py-4 border-b border-neutral-100">
          <h3 className="text-lg font-semibold text-black">Email Content</h3>
          <button
            onClick={onClose}
            aria-label="Close"
            className="border border-transparent p-1 transition-colors rounded-md text-neutral-400 hover:text-primary-700 hover:bg-primary-50 focus:outline-none focus-visible:border-primary-700"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Modal Body */}
        <dl className="flex-1 px-6 py-4 overflow-y-auto">
          <DetailField
            className="mb-4"
            label="Subject"
            value={<span className="font-medium">{emailContent.subject}</span>}
          />

          <DetailField
            label="Body"
            value={
              <div
                className="p-4 border rounded-lg prose prose-sm max-w-none bg-neutral-50 border-neutral-200"
                dangerouslySetInnerHTML={{ __html: emailContent.body }}
              />
            }
          />
        </dl>

        {/* Modal Footer */}
        <div className="flex items-center justify-end flex-shrink-0 px-6 py-4 border-t rounded-b-lg border-neutral-100 bg-neutral-50">
          <Button
            variant="neutral"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmailContentModal;